// extracted by mini-css-extract-plugin
export var cardIcon = "_88-5";
export var cardIconUnframed = "_88-9";
export var checkboxCard = "_88-0";
export var checkboxCardSelected = "_88-4";
export var disabled = "_88-2";
export var interactive = "_88-1";
export var outerBorder = "_88-3";
export var spacerMedium = "_88-8";
export var spacerSmall = "_88-7";
export var spacerXsmall = "_88-6";